import { StudentDocuments } from "@/pages/cursisten/$studentId/documenten"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/cursisten/$studentId/documenten/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "students"),
})

function RouteComponent() {
  const { studentId } = useParams({
    from: "/beheer/cursisten/$studentId",
  })

  return <StudentDocuments studentId={Number(studentId)} />
}
